export default (): string[] => [
  "NO",
  "SE",
  "DK",
  "FI",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AG",
  "AR",
  "AM",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BE",
  "BZ",
  "BJ",
  "BT",
  "BO",
  "BA",
  "BW",
  "BR",
  "BN",
  "BG",
  "BF",
  "CV",
  "KH",
  "CM",
  "CA",
  "TD",
  "CL",
  "CN",
  "CO",
  "KM",
  "CG",
  "CR",
  "CI",
  "HR",
  "CU",
  "CY",
  "CZ",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FJ",
  "FR",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GR",
  "GD",
  "GT",
  "GY",
  "HT",
  "HN",
  "HU",
  "IS",
  "IN",
  "ID",
  "IE",
  "IL",
  "IT",
  "JM",
  "JP",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KW",
  "KG",
  "LA",
  "LV",
  "LS",
  "LR",
  "LI",
  "LT",
  "LU",
  "MG",
  "MW",
  "MY",
  "MV",
  "MT",
  "MH",
  "MR",
  "MU",
  "MX",
  "FM",
  "MC",
  "MN",
  "ME",
  "MA",
  "MZ",
  "NA",
  "NR",
  "NP",
  "NL",
  "NZ",
  "NE",
  "NG",
  "MK",
  "OM",
  "PK",
  "PW",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PL",
  "PT",
  "QA",
  "KR",
  "MD",
  "RO",
  "RW",
  "KN",
  "LC",
  "VC",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SK",
  "SI",
  "SB",
  "ZA",
  "SS",
  "ES",
  "LK",
  "SR",
  "CH",
  "TW",
  "TJ",
  "TH",
  "TL",
  "TG",
  "TO",
  "TT",
  "TR",
  "TM",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "TZ",
  "US",
  "UY",
  "UZ",
  "VU",
  "VN",
  "ZM",
];
